<!--主播信息栏-->
<template>
  <div class="room-introduction">
    <div class="room-introduction-box">
      <div class="title">{{ $t('introduction.title') }}</div>
      <div class="content" ref="contentEl" :class="{expanded}">
        <div class="content-text" ref="contentTextEl">{{roomInfo?.top_message}}</div>
        <div class="txt-end-mask" v-if="hasMore">
          <transition name="fade">
            <span v-if="!expanded">...</span>
          </transition>
          <div class="expand-icon" @click="toggle"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import type { IRoomInfoResponseData } from '@/service/room/types';

const props = defineProps<{
  roomInfo: IRoomInfoResponseData;
}>();

const contentEl = ref<HTMLElement>();
const contentTextEl = ref<HTMLElement>();
const hasMore = ref(false);
const expanded = ref(false);
const toggle = e => {
  e.stopPropagation();
  expanded.value = !expanded.value;
};
const unexpand = () => {
  if (expanded.value) {
    expanded.value = false;
  }
};
onMounted(async () => {
  // 设置直播间介绍展示更多
  if (contentTextEl.value.offsetHeight > contentEl.value.offsetHeight) {
    hasMore.value = true;
  }
  document.body.addEventListener('click', unexpand);
});
onUnmounted(async () => {
  document.body.removeEventListener('click', unexpand);
});
</script>


<style lang="less" scoped>
.room-introduction {
  position: relative;
  width: 100%;
  height: 100%;

  .room-introduction-box {
    transform: rotateZ(360deg);
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    padding: 0 16px;
    background: #fff;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 8px;
    padding-bottom: 10px;

    .title {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      font-size: 18px;
      color: #333;
      letter-spacing: 0;
      font-weight: 700;
    }

    .content {
      position: relative;
      padding-top: 10px;
      font-size: 14px;
      line-height: 18px;
      max-height: 64px;
      min-height: 64px;
      color: #666;
      font-weight: 400;
      overflow: hidden;
      word-break: break-all;
      will-change: max-height;
      transition: max-height 0.5s linear;
      // text-overflow: ellipsis;
      // display: -webkit-box !important;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 3;
      .content-text {
        white-space: pre-line;
      }

      &.expanded {
        max-height: 500px;

        .expand-icon {
          transform: rotateZ(180deg);
        }
      }

      .txt-end-mask {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 36px;
        height: 18px;
        padding-left: 6px;
        text-align: left;
        background: linear-gradient(to right, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 1));

        .expand-icon {
          width: 18px;
          height: 18px;
          position: absolute;
          right: 0;
          top: 0;
          background: url('@/assets/arrow-black.svg') no-repeat center center;
          background-size: 100%;
          transition: transform 0.2s linear;
        }
      }
    }
  }
}

.fade-enter-active {
  transition: opacity 1.2s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
